// restaurantsApi.js
// Marketplace restaurant directory. Talks to GET /restaurants when the endpoint
// exists; otherwise falls back to a local seed so the guest marketplace always
// renders (mirrors menuApi.js). Darcy's is the only restaurant under contract today.

const API_BASE = 'https://z51smv2b7g.execute-api.ap-southeast-2.amazonaws.com/prod';

// Local fallback / seed — keep in sync with backend seed-darcys.js.
export const SEED_RESTAURANTS = [
  {
    restaurantId: 'darcys',
    name: "Darcy's",
    tagline: 'Room dining, delivered to your door',
    cuisine: 'Modern Australian',
    emoji: '🍽️',
    heroImage: '',
    logo: '',
    brandColor: '#E8001D',
    etaMins: '20–30',
    active: true,
  },
];

function normalize(r) {
  return {
    restaurantId: r.restaurantId || r.id,
    name: r.name || 'Restaurant',
    tagline: r.tagline || '',
    cuisine: r.cuisine || '',
    emoji: r.emoji || '🍽️',
    heroImage: r.heroImage || '',
    logo: r.logo || '',
    brandColor: r.brandColor || '#E8001D',
    etaMins: r.etaMins || '20–30',
    active: r.active !== false,
  };
}

export async function getRestaurants() {
  try {
    const res = await fetch(API_BASE + '/restaurants', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) throw new Error('restaurants endpoint not ready');
    const data = await res.json();
    const list = Array.isArray(data) ? data : Array.isArray(data.restaurants) ? data.restaurants : [];
    const active = list.map(normalize).filter((r) => r.active);
    if (active.length) return active;
    throw new Error('empty restaurants');
  } catch (e) {
    return SEED_RESTAURANTS.map(normalize);
  }
}

export async function getRestaurant(restaurantId) {
  const all = await getRestaurants();
  return all.find((r) => r.restaurantId === restaurantId) || null;
}

const restaurantsApi = { getRestaurants, getRestaurant, SEED_RESTAURANTS };
export default restaurantsApi;
